import React from 'react';

import { Col, Row } from 'react-bootstrap';
import Text from 'v3/components/Text';
import { formatCurrency } from 'utils/formatter';
import { USD_PRECISION } from '../../context';

export function SummaryRow({ label, totalInReal, totalInDollar, id }) {
  return (
    <>
      <hr style={{ height: '1px' }} />
      <Row className="my-2">
        <Col md={2}>
          <Text type="regular" weight={500}>
            {label}
          </Text>
        </Col>
        <Col md={1} />
        <Col className='d-flex' md={6} style={{
          paddingRight: '60px'
        }}>
          <Col md={6}>
            <Text id={id && `label-${id}-real`} type="regular">
              {formatCurrency(totalInReal, 'BRL')}
            </Text>
          </Col>
          <Col md={6}>
            <Text id={id && `label-${id}-dolar`} type="regular">
              {formatCurrency(totalInDollar, 'USD', '$', USD_PRECISION)}
            </Text>
          </Col>
        </Col>
        <Col md={3} />
      </Row>
    </>
  );
}
